import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';

import { useDispatch, useSelector } from 'hooks';
import useCurrentStep from 'hooks/useCurrentStep';

import socketSlice from 'modules/sockets/reducer';

import { getStepToRedirect, isModalDisplayed } from 'modules/sockets/selectors';
import { buildStepUrl, getBasePath } from 'utils/stepUrlUtils';

import { Button, Modal } from '../ui';

const SocketRedirectModal: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const ref = React.useRef<HTMLButtonElement>(null);

  const displayModal = useSelector(isModalDisplayed);
  const currentStep = useCurrentStep();
  const stepToRedirect = useSelector(getStepToRedirect);

  const handleCloseModal = React.useCallback(() => {
    dispatch(socketSlice.actions.closeModal());

    if (stepToRedirect !== currentStep) {
      const basePath = getBasePath(location.pathname);
      const url = buildStepUrl(basePath, stepToRedirect, location.search.replace('?', ''));
      navigate(url, { replace: true, state: location.state });
    }
  }, [location, currentStep, stepToRedirect, navigate, dispatch]);

  return displayModal && (
    <Modal
      open
      focusRef={ref}
      className="modal-large"
      title={(
        <h3 className="text-center">
          <FormattedMessage
            id="socket.modal.title"
            defaultMessage="We have updated your file."
          />
        </h3>
      )}
    >
      <div className="flex flex-col items-center mt-5">
        <Button
          ref={ref}
          testId="showMe"
          onClick={handleCloseModal}
          className="w-full mt-5"
        >
          <FormattedMessage id="socket.modal.confirm" defaultMessage="Continue" />
        </Button>
      </div>
    </Modal>
  );
};

export default SocketRedirectModal;
